import { intlFormat } from 'date-fns';

export const createCookieInHour = (
  cookieName: string,
  cookieValue: string,
  hourToExpire?: number,
) => {
  const date = new Date();
  date.setTime(date.getTime() + hourToExpire * 60 * 60 * 1000);
  return (document.cookie = `${cookieName} = ${cookieValue}; domain = ${process.env.REACT_APP_COOKIE_DOMAIN}; path = '/'`);
};

export const cookieTokenValue = () => {
  return document.cookie
    ?.split('; ')
    ?.find((row) => row.startsWith('token'))
    ?.split('=')[1];
};

export const formatDate = (data: string) => {
  return intlFormat(new Date(data), {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const formatDateTime = (data: string) => {
  return intlFormat(new Date(data), {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const formatNowDate = () => {
  return intlFormat(new Date(), {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const formatDayOrMonth = (date: number) =>
  date < 10 ? `0${date}` : date.toString();

export const changeDateFormatDDMMYYYY = (fullDate: Date, symbol?: string) => {
  const day = fullDate.getDate();
  const month = fullDate.getMonth() + 1;
  const year = fullDate.getFullYear();
  const splitSymbol: string = symbol ?? '-';
  return `${formatDayOrMonth(day)}${splitSymbol}${formatDayOrMonth(
    month,
  )}${splitSymbol}${year}`;
};

export const changeDateFormatDDMMYYYYTIME = (
  fullDate: Date,
  symbol?: string,
) => {
  const day = fullDate.getDate();
  const month = fullDate.getMonth() + 1;
  const year = fullDate.getFullYear();
  const hours = fullDate.getHours();
  const mins = fullDate.getMinutes();
  const splitSymbol: string = symbol ?? '-';
  return `${formatDayOrMonth(day)}${splitSymbol}${formatDayOrMonth(
    month,
  )}${splitSymbol}${year} ${hours < 10 ? `0${hours}` : hours}:${
    mins < 10 ? `0${mins}` : mins
  }`;
};
